<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новое пуш уведомление</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                    </span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="push_title"
                        v-model="push.title"
                        v-validate="'required'"
                        data-vv-name="title"
                        :error-messages="errors.collect('title')"
                        text
                        solo
                        single-line
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Сообщение</v-subheader>
                            <v-textarea
                                ref="push_body"
                                v-model="push.body"
                                v-validate="'required|max:140'"
                                data-vv-name="body"
                                :error-messages="errors.collect('body')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="push.status ? 'Включен' : 'Отключен'" v-model="push.status"
                                        class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                        <upload-img :image-width="500" :image-height="500" v-model="push.img" :content-area="5"
                                    style="max-width: 253px;">
                            <div slot="activator">
                                <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-if="!push.img">
                                    <img src="/static/img/media/image_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для пуша"/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile v-else>
                                    <img :src="push.img.imageURL" alt="Изображение для пуша"/>
                                </v-avatar>
                            </div>
                        </upload-img>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">День отправки</v-subheader>
                            <v-menu
                                ref="savedDate"
                                v-model="savedDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="push.date"
                                        readonly
                                        v-on="on"
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="endPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="push.date"
                                    :min="new Date(tomorrow).toISOString().substr(0, 10)"
                                    :max="new Date(maxDate).toISOString().substr(0, 10)"
                                    @change="saveDate"/>
                            </v-menu>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Время отправки</v-subheader>
                            <v-dialog
                                ref="dialog"
                                v-model="showTime"
                                :return-value.sync="push.time"
                                persistent
                                lazy
                                full-width
                                width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="push.time"
                                        single-line
                                        text
                                        solo
                                        v-on="on"
                                        readonly/>
                                </template>
                                <v-time-picker
                                    v-if="showTime"
                                    v-model="push.time"
                                    format="24hr"
                                    :allowed-minutes="allowedStep"
                                    full-width>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="showTime = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(push.time)">OK</v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Выберите тип акции</v-subheader>
                            <v-select
                                :items="types"
                                item-value="key"
                                item-text="value"
                                v-model="push.type"
                                @change="changeStock"
                                required
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Выберите акцию</v-subheader>
                            <v-select
                                :items="stock"
                                item-value="id"
                                item-text="name"
                                v-model="push.stock_id"
                                text
                                solo/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Тип пользователей</v-subheader>
                            <v-select
                                :items="customers"
                                item-value="key"
                                item-text="value"
                                v-model="push.customer"
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Устройства</v-subheader>
                            <v-select
                                :items="devices"
                                item-value="key"
                                item-text="value"
                                v-model="push.device"
                                text
                                solo/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Пол пользователей</v-subheader>
                            <v-select
                                :items="sex"
                                item-value="key"
                                item-text="value"
                                v-model="push.sex"
                                text
                                solo/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0 mb-3">Выберите возраст</v-subheader>
                    <v-layout>
                        <!--<v-flex shrink style="width: 40px">
                            <v-text-field
                                v-model="push.age[0]"
                                class="mt-0"
                                hide-details
                                single-line
                                type="number" />
                        </v-flex>-->
<!--                        <v-spacer/>-->
                        <v-flex class="mt-7 ml-2" xs5>
                            <v-range-slider
                                v-model="push.age"
                                :max="100"
                                :min="18"
                                thumb-label="always"
                                :step="1"/>
                        </v-flex>
<!--                        <v-spacer/>-->
                        <!--<v-flex shrink style="width: 40px">
                            <v-text-field
                                v-model="push.age[1]"
                                class="mt-0"
                                hide-details
                                single-line
                                type="number" />
                        </v-flex>-->
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import UploadImg from '../../../components/Media/Upload'
    import Push from '../../../api/push'
    import StockCatalog from '../../../api/stockcatalog'
    import StockRegister from '../../../api/stockregister'

    export default {
        name: 'addPush',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            push: {
                title: '',
                body: '',
                img: '',
                date: null,
                time: null,
                type: 0,
                sex: null,
                age: [18, 100],
                stock_id: null,
                device: null,
                status: true,
                customer: null,
            },
            savedDate: false,
            tomorrow: new Date(),
            maxDate: new Date(),
            showTime: false,
            allowedStep: m => m % 30 === 0,
            types: [
                {
                    key: 1,
                    value: 'Скидки'
                },
                {
                    key: 2,
                    value: 'Бонус за регистрацию'
                }
            ],
            stock: [],
            customers: [
                {
                    key: 0,
                    value: 'Все'
                },
                {
                    key: 1,
                    value: 'Зарегестрированные'
                }
            ],
            devices: [
                {
                    key: 0,
                    value: 'Все'
                },
                {
                    key: 1,
                    value: 'iOs'
                },
                {
                    key: 2,
                    value: 'Android'
                }
            ],
            sex: [
                {
                    key: 0,
                    value: 'Все'
                },
                {
                    key: 1,
                    value: 'Мужской'
                },
                {
                    key: 2,
                    value: 'Женский'
                }
            ],
            dictionary: {
                custom: {
                    title: {
                        required: 'Название не введено'
                    },
                    body: {
                        required: 'Текст не введен'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
            this.tomorrow = new Date()
            this.tomorrow.setDate(this.tomorrow.getDate() + 1)
            this.maxDate = new Date()
            this.maxDate.setDate(this.maxDate.getDate() + 30)
        },
        methods: {
            saveDate (date) {
                this.$refs.savedDate.save(date)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Push
                            .create(this.push)
                            .then(response => {
                                this.$store.commit('storePush', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Пуш создан',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'pushRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            changeStock (value) {
                this.stock = []

                if (value === 1) {
                    StockCatalog
                        .getLastActive()
                        .then(response => {
                            if (response.data.data) this.stock = response.data.data
                        })
                } else {
                    StockRegister
                        .getLastActive()
                        .then(response => {
                            if (response.data.data) this.stock = response.data.data
                        })
                }
            }
        }
    }
</script>
